import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar/Sidebar";
import "./Dashboard.css";
import Navbar from "./Innercontent/Navbar";
import Header from "./Innercontent/header";
import ApiConfig from "../common/config/ApiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddCardIcon from "@mui/icons-material/AddCard";
import TopupCreditModal from "./Modals/TopupCreditModal";
import { useLanguage } from "../common/i18n/LanguageContext";

function Dashboard() {
  const { t } = useLanguage();
  const [detail, setDetail] = useState();
  const [profitdetail, setProfitDetail] = useState();
  const [isTopupOpen, setIsTopupOpen] = useState(false);
  const user = localStorage.getItem("user");
  const pos = localStorage.getItem("position");
  const subuser = localStorage.getItem("subuser");

  const usedetail = () => {
    ApiConfig.get(`/agentprofile?user=${encodeURIComponent(user)}`).then(
      (result) => {
        if (result.resCode === 200) {
          setDetail(result.data);
        } else {
          toast.error(result.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      },
    );
  };
  const useprofitdetail = () => {
    ApiConfig.get(
      `/agentprofile_profit?user=${encodeURIComponent(user)}`,
    ).then((result) => {
      if (result.resCode === 200) {
        setProfitDetail(result.data);
      } else {
        toast.error(result.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    });
  };

  useEffect(() => {
    usedetail();
    useprofitdetail();
    //  eslint-disable-next-line
  }, []);
  return (
    <div>
      <Navbar />
      <div className="contain">
        <Sidebar pos={pos} />
        <div className="inner">
          <div className="content flex flex-col">
            <Header title={t("dashboard_title")} />

            <table id="statistics" className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_login_id")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {pos === "sub_account" ? subuser : user}
                    {/* {detail && detail.username} */}
                  </td>
                </tr>
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_credit")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-sky-500">
                    <div className="flex items-center gap-2">
                      {detail &&
                        parseFloat(detail.credit).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      {pos === "owner" && (
                        <button
                          onClick={() => setIsTopupOpen(true)}
                          className="bg-green-500 text-white hover:bg-green-700 font-bold py-1 px-3 rounded text-xs"
                        >
                          <AddCardIcon className="text-xs md:text-base" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_member_count")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {detail && detail.member_count}
                  </td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_downline_count")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {detail && detail.downline_count}
                  </td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_bet_amount")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {profitdetail &&
                      parseFloat(profitdetail.win).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_loss_amount")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {profitdetail &&
                      parseFloat(profitdetail.lose).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 text-[14px] font-medium text-gray-600">
                    {t("dashboard_profit")}
                  </th>
                  <td className="text-left px-3 py-2 text-[14px] font-semibold text-gray-800">
                    {profitdetail &&
                      parseFloat(profitdetail.profit).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <div className='py-2 flex flex-col gap-y-2'>
            <Header title='Hot Number' />

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">รัฐบาลไทย</td>
                </tr>
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">รางวัลที่ 1</th>
                  <td className="text-left px-3 py-2 font-semibold text-sky-500"></td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">4 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">4 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวหน้า</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวหลัง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>

              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">รัฐบาลลาว</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">ฮานอย</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">ยี่กี่ปกติ</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">ยี่กี่ VIP</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">ยี่กี่ VVIP</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

            <table className="table-auto w-full">
              <tbody className="bg-white rounded-lg shadow">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">ประเภทหวย</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">รัฐบาลลาว</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">3 ตัวโต๊ด</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">2 ตัวล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งบน</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
                <tr className="border-b border-gray-300 rounded-bl-lg">
                  <th className="text-left px-3 py-2 font-medium text-gray-600">วิ่งล่าง</th>
                  <td className="text-left px-3 py-2 font-semibold text-gray-800">{}</td>
                </tr>
              </tbody>
            </table>

          </div> */}
          </div>
        </div>
      </div>
      <TopupCreditModal
        isOpen={isTopupOpen}
        onClose={() => setIsTopupOpen(false)}
        onSuccess={usedetail}
        agentId={detail?.id}
      />
    </div>
  );
}

export default Dashboard;
